export const setAvatar = (filter: any) => ({
    type: 'SET_AVATAR',
    payload: filter,
  });
  